import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property, query, state } from 'lit/decorators.js';
import componentStyles from './tufts-search-bar.css.lit';

/**
 * The TuftsSearchBar component
 * @element tufts-search-bar
 *
 * @slot - A default slot
 */
@customElement('tufts-search-bar')
export class TuftsSearchBar extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @state() showLoading = false;
  private escapeListenerAdded = false;
  @query('slot') slotElement: HTMLSlotElement;
  @property({
    type: Boolean,
    reflect: true,
    attribute: 'disable-loading-indicator',
  })
  disableLoadingIndicator = false;

  firstUpdated() {
    this.setupFormEventListeners();
  }

  setupFormEventListeners() {
    const nodes = this.slotElement.assignedNodes();

    const form = nodes.find(node => node instanceof HTMLFormElement) as
      | HTMLFormElement
      | undefined;
    if (form) {
      const submitButton = form.querySelector(
        'input[type="submit"], button[type="submit"]'
      );
      if (submitButton) {
        submitButton.addEventListener('click', () => this.handleButtonClick());
      }
    }
  }

  handleButtonClick() {
    this.showLoading = true;
    if (!this.escapeListenerAdded) {
      document.addEventListener('keydown', event =>
        this._handleEscapeKey(event)
      );
      this.escapeListenerAdded = true;
    }
  }

  _handleEscapeKey(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.showLoading = false;
    }
  }

  render(): TemplateResult {
    return html` <slot></slot>
      ${this.showLoading && !this.disableLoadingIndicator
        ? this.displayPending()
        : null}`;
  }
  displayPending() {
    return html`
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('keydown', this._handleEscapeKey);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-search-bar': TuftsSearchBar;
  }
}
